export default __webpack_public_path__ + "static/media/santa-on-zoom.a7d9f281.jpg";